import { createFeatureSelector } from '@ngrx/store';

import { MODULE_KEY } from '../../constants';
import { AccidentState } from '../reducers';

export const selectAccidentParticipantModuleState = createFeatureSelector<AccidentState>(MODULE_KEY);
